// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-picker-panel__shortcut {\n  margin-bottom: 0;\n  height: 28px;\n  line-height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
